import React from 'react';
import EducationSection from './EducationSection/EducationSection';
import EmploymentSection from './EmploymentSection/EmploymentSection';
import styles from './AdvancedCriteria.module.scss';
import PersonalInformationSection from './PersonalSection/PersonalInformationSection';
import {
  getPersonalInfoSupportedSourceName,
  diversityMessageForNameAndUniversity,
} from '../../../Utils/ManualSearchUtils';

function AdvancedCriteria(props) {
  const { form, defaultFormValues, industries, candidateContext, sources, maskingConfig } = props;
  const sourceName = getPersonalInfoSupportedSourceName(sources);
  return (
    <div className={styles.advancedCriteriaWrapper}>
      <EducationSection
        form={form}
        defaultFormValues={defaultFormValues}
        maskingConfig={maskingConfig}
        diversityForUniversityText={diversityMessageForNameAndUniversity}
      />
      <EmploymentSection
        form={form}
        defaultFormValues={defaultFormValues}
        industries={industries}
        candidateContext={candidateContext}
        sourceName={sourceName}
      />
      <PersonalInformationSection
        form={form}
        defaultFormValues={defaultFormValues}
        sourceName={sourceName}
        maskingConfig={maskingConfig}
        diversityForNameText={diversityMessageForNameAndUniversity}
      />
    </div>
  );
}

export default React.memo(AdvancedCriteria);
